// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Party & bulk planner  (portion guide for pages/PartyPlanner.tsx)
// BUSINESS-CONFIGURABLE ROUGH GUIDE — not a promise or a measured yield: how much seafood (kg of pack weight, before cleaning) a host
// might plan per guest for each kind of gathering. The planner uses it only to suggest a total; the customer picks the real catches
// and packs. Change the numbers here. Bulk/tier discounts do not exist and are not shown.
// ─────────────────────────────────────────────────────────────────────────────
export interface EventProfile {
  id: string;
  label: string;
  /** kg of pack weight per guest. */
  kgPerGuest: number;
}

export const EVENT_PROFILES: EventProfile[] = [
  { id: "family", label: "Family feast", kgPerGuest: 0.38 },
  { id: "bbq", label: "BBQ & grilling", kgPerGuest: 0.45 },
  { id: "wedding", label: "Wedding / reception", kgPerGuest: 0.32 },
  { id: "festival", label: "Festival special", kgPerGuest: 0.4 },
];

export const MIN_GUESTS = 2;
export const MAX_GUESTS = 200;
export const DEFAULT_GUESTS = 12;

export const recommendedKg = (guests: number, profile: EventProfile) => Math.round(guests * profile.kgPerGuest * 10) / 10;
